<template>
  <component :is="componentType" :component="component" :index="index" />
</template>

<script setup lang="ts">
  import type { PageComponent } from '~/types/graphql';

  const { component } = defineProps<{
    component: PageComponent;
    index: number;
  }>();

  // INFO: while creating a mapping instead of this looks better
  // the compiler cannot resolve the component names, leave this as is!
  const componentType = computed(() => {
    switch (component.__typename) {
      case 'ComponentPageComponentsAwards':
        return resolveComponent('LazyPageComponentsAwards');
      case 'ComponentPageComponentsAutoUncleSellingForm':
        return resolveComponent('LazyPageComponentsAutoUncleSellingForm');
      case 'ComponentPageComponentsHero':
        return resolveComponent('LazyPageComponentsHero');
      case 'ComponentPageComponentsSimpleText':
        return resolveComponent('LazyPageComponentsSimpleText');
      case 'ComponentPageComponentsTextBox':
        return resolveComponent('LazyPageComponentsTextBox');
      case 'ComponentPageComponentsImage':
        return resolveComponent('LazyPageComponentsImage');
      case 'ComponentPageComponentsHeroSlider':
        return resolveComponent('LazyPageComponentsHeroSlider');
      case 'ComponentPageComponentsSpotlightWithSearch':
        return resolveComponent('LazyPageComponentsSpotlightWithSearch');
      case 'ComponentPageComponentsFeaturedCars':
        return resolveComponent('LazyPageComponentsFeaturedCars');
      case 'ComponentPageComponentsAiSearch':
        return resolveComponent('LazyPageComponentsAISearch');
      case 'ComponentPageComponentsFeaturedCategories':
        return resolveComponent('LazyPageComponentsFeaturedCategories');
      case 'ComponentPageComponentsServiceOfferings':
        return resolveComponent('LazyPageComponentsServiceOfferings');
      case 'ComponentPageComponentsTestimonialsSlider':
        return resolveComponent('LazyPageComponentsTestimonialsSlider');
      case 'ComponentPageComponentsHighlightedSteps':
        return resolveComponent('LazyPageComponentsHighlightedSteps');
      case 'ComponentPageComponentsNewsletterSignupForm':
        return resolveComponent('LazyPageComponentsNewsletterSignupForm');
      case 'ComponentPageComponentsContactForm':
        return resolveComponent('LazyPageComponentsContactForm');
      case 'ComponentPageComponentsLocations':
        return resolveComponent('LazyPageComponentsLocations');
      case 'ComponentPageComponentsCtAs':
        return resolveComponent('LazyPageComponentsCtas');
      case 'ComponentPageComponentsNewsArticleArchive':
        return resolveComponent('LazyPageComponentsNewsArticleArchive');
      case 'ComponentPageComponentsEventsArchive':
        return resolveComponent('LazyPageComponentsEventsArchive');
      case 'ComponentPageComponentsFeaturedNewsAndEvents':
        return resolveComponent('LazyPageComponentsFeaturedNewsAndEvents');
      case 'ComponentPageComponentsThreeColIcons':
        return resolveComponent('LazyPageComponentsThreeColIcons');
      case 'ComponentPageComponentsFaQs':
        return resolveComponent('LazyPageComponentsFAQs');
      case 'ComponentPageComponentsTeamMembers':
        return resolveComponent('LazyPageComponentsTeamMembers');
      case 'ComponentPageComponentsCarDetail':
        return resolveComponent('LazyPageComponentsCarDetail');
      case 'ComponentPageComponentsCarSearch':
        return resolveComponent('LazyPageComponentsCarSearch');
      case 'ComponentPageComponentsIFrame':
        return resolveComponent('LazyPageComponentsIFrame');
      case 'ComponentPageComponentsThreeBoxComponent':
        return resolveComponent('LazyPageComponentsThreeBoxComponent');
      case 'ComponentPageComponentsWorkshopCalendar':
        return resolveComponent('LazyPageComponentsWorkshopBooking');
      case 'ComponentPageComponentsSellingForm':
        return resolveComponent('LazyPageComponentsSellingForm');
      case 'ComponentPageComponentsOffersArchive':
        return resolveComponent('LazyPageComponentsOffersArchive');
      case 'ComponentPageComponentsCounter':
        return resolveComponent('LazyPageComponentsCounter');
      case 'ComponentPageComponentsISwipeCalculator':
        return resolveComponent('LazyPageComponentsISwipeCalculator');
      case 'ComponentPageComponentsImageGalery':
        return resolveComponent('LazyPageComponentsImageGalery');
      default:
        console.warn(`Unknown component type: ${component.__typename}`);
        return null;
    }
  });
</script>
